import { GENDER } from '../../domain/domainCodes.js'
/**
 * Legacy strings for ملف المستخدم and the system pages —
 * Locale/UserProfile.ar.resx, Locale/General.ar.resx, Locale/Shutdown.ar.resx
 * and Locale/TermsOfUse.ar.resx.
 */

export const profileStrings = {
  title: 'معلومات الملف الشخصي', // UserProfile.MainPanelHeader
  subtitle:
    'استخدم هذه الصفحة لتحديث بياناتك الشخصية بالشكل الذي يلائمك. يظهر الاسم في الشهادة كما تكتبه هنا, لذلك تأكد من كتابته بالطريقة التي ترغب بها..', // MainPanelSubHeader
  save: 'حفظ', // btnUpdateResource1_Text
  saved: 'تم تحديث الملف الشخصي', // ProfileUpdatedMessage
  close: 'إغلاق', // Users.btnClose

  fields: {
    Username: 'اسم المستخدم', // LabelUsernameResource1_Text
    EnglishName: 'الاسم الكامل باللغة الإنجليزية', // Label2Resource1_Text
    ArabicName: 'الاسم الكامل باللغة العربية', // Label10Resource1_Text
    Gender: 'الجنس', // Label3Resource1_Text
    Email: 'البريد الإلكتروني', // Label4Resource1_Text
    Phone: 'رقم الهاتف', // Label5Resource1_Text
    Mobile: 'رقم الجوال', // Label6Resource1_Text
    EmployeeId: 'رقم الموظف', // LabelEmployeeIdResource1_Text
    DepartmentId: 'الإدارة', // Label7Resource1_Text
  },

  /** The view renders the fields in this order. */
  order: [
    'Username',
    'EnglishName',
    'ArabicName',
    'Gender',
    'Email',
    'Phone',
    'Mobile',
    'EmployeeId',
    'DepartmentId',
    'Attribute1',
    'Attribute2',
    'Attribute3',
    'Attribute4',
    'Attribute5',
  ],

  /** Username, both names and the email carry the required marker. */
  required: ['Username', 'EnglishName', 'ArabicName', 'Email'],

  genders: [
    { value: String(GENDER.MALE), label: 'ذكر' }, // ListItemResource1_Text
    { value: String(GENDER.FEMALE), label: 'أنثى' }, // ListItemResource2_Text
  ],

  validation: {
    ArabicName:
      'الاسم باللغة العربية يجب ان لا يتجاوز 100 حرف ولا يقل عن 2 و يجب أن يكون حروف عربية فقط', // RegularExpressionValidatorQuestion4Resource1_ErrorMessage
    EnglishName:
      'الاسم باللغة الإنجليزية يجب ان لا يتجاوز 100 حرف ولا يقل عن 2 و يجب أن يكون فقط حروف انجليزية', // RegularExpressionValidatorQuestionResource1_ErrorMessage
    Email: 'البريد الإلكترني غير صحيح', // RegularExpressionValidator1Resource1_ErrorMessage
    Phone: 'رقم الهاتف يجب ان لا يتجاوز 100 رقم ولا يقل عن 4 و لا يقبل إلا أرقام', // RegularExpressionValidatorQuestion0Resource1
    Mobile: 'رقم الجوال يجب ان لا يتجاوز 10 رقم ولا يقل عن 4 و لا يقبل إلا أرقام', // RegularExpressionValidatorQuestion1Resource1
    requiredEnglishName: 'الاسم الكامل بالإنجليزي مطلوب', // RequiredFieldValidator2Resource1
    requiredArabicName: 'الاسم الكامل بالعربي مطلوب', // RequiredFieldValidator4Resource1
    requiredEmail: 'البريد الإلكتروني مطلوب', // RequiredFieldValidator3Resource1
  },
}

export const systemPageStrings = {
  error: {
    title: 'خطأ في النظام', // General.System_Error
    /* The resx value carries the line break, and the view adds "Sorry!" under it. */
    message: 'هناك خطأ ما!\nالرجاء معاودة المحاولة في وقت لاحق.', // General.Something_Wrong
    sorry: 'Sorry!',
    home: 'البداية', // General.Home_Title
    contact: 'اتصل بنا', // General.NavbarContactUs
  },

  unauthorized: {
    title: 'غير مصرح!', // General.Unauthorized
    message: 'لا تملك الصلاحيات لتصفح هذه الصفحة', // General.UnauthorizedMsg
    home: 'البداية', // General.Home_Title
  },

  shutdown: {
    title: 'النظام مغلق', // Shutdown.PageResource1_Title
    heading: 'عفوا ، النظام مغلق', // Label1Resource1_Text
    message: 'لمزيد من التفاصيل، يرجى الرجوع إلى مسؤول النظام', // Label2Resource1_Text
    /* Only a settings manager sees this line and the licence button. */
    managerNote: 'يمكن الضغط على زر تحديث بيانات الترخيص من أجل تحديث بيانات الرخصة', // Label3Resource1_Text
    licenseLink: 'تحديث بيانات الترخيص', // HyperLinkResource1_Text
    logout: 'تسجيل خروج', // TermsOfUse.BtnLogout_Text
  },

  /* /Redirect - the interstitial shown the first time someone signs in with an
     incomplete profile. The server composes its own sentence, including the
     installation's application title; these are the fallback. */
  redirect: {
    title: 'تحديث الملف الشخصي',
    message: 'سيتم توجيهك إلى صفحة الملف الشخصي لتحديث الإدخالات الضرورية',
    go: 'المتابعة الآن',
  },
}
